export enum RouteSlug {
  HOME = '',

  APART = 'konkurslorealparisxapart',
  ALLEGRO = 'konkurslorealparisxallegro',
  BODYCERAVE = 'cerave',
  VICHY = 'vichy',
  TEDDYTINT = 'teddytint',
  HAIRSPACE = 'konkurslorealprofessionnelparis',
  MAYBELLINE_GRIPPY = 'grippyserum',
  MAYBELLINE_NY = 'mnyevent',
  SKYHIGH = 'konkursmnyskyhigh',
  MAYBELLINENYXNYXPM = 'maybellinenyxnyxpm',
  LOREAL_APART = 'lorealpariskonkurs',
  MATRIX_META = 'matrixkonkursmetamorfoza',
  LP_META = 'lpkonkursmetamorfoza',
  GARNIER = 'garniermiasteczkobiegowe',
  GARNIER_FRUCTIS = 'konkurs-garnier-fructis-end',
  FAT_SUMMER = 'fat-summer',
  MIXA = 'konkursmixahyalurogel',
  YSL = 'yslxnotinokonkurs',
  MNY_YOUNG_TALENTS = 'mnyyoungtalents',
  LOREAL_PARIS_EVENT = 'lorealparisevent',
  MNY_MUSIC_STORIES = 'mnymusicstoriesxlorealmex',
  MNY_MUSIC_STORIES_2 = 'akcjatestowania',
  GARNIER_SORBET = 'garniersorbetomania',
  GARNIER_SORBET_CONTEST = 'garniersorbetomaniakonkurs',
  LOREALPARIS_GLASS_SKIN = 'lorealparis-glass-skin',
  LOREALPARIS_GLASS_SKIN_CONTEST = 'lorealparis-glass-skin-konkurs',
  LOREALPARIS_TESTERS = 'testowanielorealparis',
  LOREALPARIS_TESTERS_2 = 'testowanielorealparis2',
  LOREAL_LUXY = 'luxegolive',
  GARNIER_OLIA = 'testowaniegarnier-olia-gloss',
  TESTOWANIE_MNY_JUWENALIA = 'testowaniemnyjuwenalia',
  TESTOWANIEMNYNYXPM = 'testowanie-mny-nyxpm',
  LE_DEFILE = 'le-defile',
  LE_DEFILE_VIP = 'le-defile-vip',

  PREVIEW = 'preview',
  OFFLINE_SYNC = 'offline-sync',
  COOKIES_POLICY = 'cookies-policy',
  PRIVACY_POLICY = 'privacy-policy',
  NOT_FOUND_PAGE = '404',
}
